//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PageLayout from '@/components/page/PageLayout';
import RouteView from "@/components/layouts/RouteView";
import { mixinDevice } from '@/utils/mixin.js';
export default {
  components: {
    RouteView: RouteView,
    PageLayout: PageLayout
  },
  mixins: [mixinDevice],
  data: function data() {
    return {
      // horizontal  inline
      mode: 'inline',
      mainInfoHeight: "100%",
      openKeys: [],
      defaultSelectedKeys: [],
      // cropper
      preview: {},
      option: {
        img: '/avatar2.jpg',
        info: true,
        size: 1,
        outputType: 'jpeg',
        canScale: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 180,
        autoCropHeight: 180,
        fixedBox: true,
        // 开启宽度和高度比例
        fixed: true,
        fixedNumber: [1, 1]
      },
      pageTitle: ''
    };
  },
  created: function created() {
    this.updateMenu();
  },
  mounted: function mounted() {
    this.mainInfoHeight = window.innerHeight - 285 + "px";
  },
  methods: {
    onOpenChange: function onOpenChange(openKeys) {
      this.openKeys = openKeys;
    },
    updateMenu: function updateMenu() {
      var routes = this.$route.matched.concat();
      this.defaultSelectedKeys = [routes.pop().path];
    }
  }
};